export const questions = [
  {
    question:
      "How would you describe your <span>level of expertise</span> when it comes to investing in cryptocurrencies?",
    options: [
      {
        value: 3,
        label: "Very experienced",
      },
      {
        value: 2,
        label: "Somewhat experienced",
      },
      {
        value: 1,
        label: "Inexperienced",
      },
    ],
    style: {
      width: 850,
    },
  },
  {
    question:
      "How familiar are you with the <span>technological</span>, <span>security</span>, <span>liquidity</span>, and <span>regulatory</span> risks that may arise when investing in cryptocurrencies?",
    options: [
      {
        value: 3,
        label: "Very familiar",
      },
      {
        value: 2,
        label: "Somewhat familiar",
      },
      {
        value: 1,
        label: "Not familiar",
      },
    ],
    style: {
      width: 832,
    },
  },
  {
    question:
      "When you are considering an investment, do you focus more on its potential <span>risks</span><br>or its potential <span>returns</span>?",
    options: [
      {
        value: 1,
        label: "I prioritize risk",
      },
      {
        value: 2,
        label: "I consider both equally",
      },
      {
        value: 3,
        label: "I prioritize returns",
      },
    ],
    style: {
      width: 795,
    },
  },
  {
    question:
      "Which of these best describes your investment <span>objective</span>?",
    options: [
      {
        value: 1,
        label: "Preserve my capital and generate modest returns",
      },
      {
        value: 2,
        label: "A combination of stability and growth",
      },
      {
        value: 3,
        label: "Maximize my returns",
      },
    ],
    style: {
      width: 634,
    },
  },
  {
    question:
      "Which of these best describes your investment <span>time horizon</span>?",
    options: [
      {
        value: 1,
        label: "More than 5 years",
      },
      {
        value: 2,
        label: "Between 1 and 5 years",
      },
      {
        value: 3,
        label: "Less than a year",
      },
    ],
    style: {
      width: 634,
    },
  },
  {
    question:
      "If your investment portfolio's value were<br>to <span>increase by 50%</span> or more over a short period,<br>what would you do?",
    options: [
      {
        value: 1,
        label: "Take profits and cash out",
      },
      {
        value: 2,
        label: "Keep holding and expect long-term growth",
      },
      {
        value: 3,
        label: "Reinvest profits into riskier, high-yield opportunities",
      },
    ],
    style: {
      width: 832,
    },
  },
  {
    question:
      "If your investment portfolio's value were<br>to <span>drop by 20%</span> or more over a short period,<br>how would you <span>feel</span> about it?",
    options: [
      {
        value: 3,
        label: "Confident - I understand it's a part of investing",
      },
      {
        value: 2,
        label: "Cautious - I would keep a close eye<br>on my investments",
      },
      {
        value: 1,
        label: "Worried - I may reevaluate my<br>investment strategy",
      },
    ],
    style: {
      width: 791,
    },
  },
  {
    question:
      "If your investment portfolio's value were<br><span>to drop by 20%</span> or more over a short period, <span>how<br>long would you be willing to wait</span> for it to recover?",
    options: [
      {
        value: 3,
        label: "Over 2 years",
      },
      {
        value: 2,
        label: "Between 6 months and 2 years",
      },
      {
        value: 1,
        label: "Less than 6 months",
      },
    ],
    style: {
      width: 877,
    },
  },
  {
    question:
      "If there were <span>negative sentiment</span> or <span>bad news</span> circulating about one of your investments,<br>how would you handle it?",
    options: [
      {
        value: 3,
        label: "I would ignore it and stick to my plan",
      },
      {
        value: 2,
        label: "I would consider it, but wait to make any decisions",
      },
      {
        value: 1,
        label: "I would sell the investment",
      },
    ],
    style: {
      width: 832,
    },
  },
  {
    question:
      "If you ended up <span>losing</span> the entire value of your investments, how would it <span>impact</span> your financial situation?",
    options: [
      {
        value: 3,
        label: "It would not affect me whatsoever",
      },
      {
        value: 2,
        label: "It would not be ideal, but I could handle it",
      },
      {
        value: 1,
        label: "It would put me in a difficult situation",
      },
    ],
    style: {
      width: 832,
    },
  },
];
